import { CoupeSDK } from '@xl/coupe-sdk';

const DEFAULT_COUPE = {
  studentAuthBanner:
    'https://act2.xiaolachuxing.com/van/random/act3-tpl-poster/driver?_env=stg&code=2XGMZrK1t3I&u=2&tpl=1&bl=8',
  studentAuthDescText: 'test'
};

export const coupeSdk = new CoupeSDK({
  // Coupe ID
  coupeId: '1fbbc4def31b4407a03c0521bca10bcb',
  origin: 'xl'
});

export default async function fetchCoupeInfo() {
  try {
    const result = (await coupeSdk.fetch()) || DEFAULT_COUPE;
    console.log('fetchCoupeInfo::::', result);
    return result;
  } catch (e) {
    console.log('fetch qrCode coupe info error', e);
  }
}
